import Topic from 'shared/topic';
import LocalStorageAdapter from 'shared/localstorage_adapter';

export default class NotificationStorage {
  static key(){
    return 'vidio_inbox_notifications';
  }

  static timeKey(){
    return 'vidio_inbox_notifications_expires_at';
  }

  static lastReadKey(){
    return 'vidio_inbox_notifications_last_read';
  }

  static lastNotificationTimeKey(){
    return 'vidio_inbox_notifications_last_notification_time';
  }

  static store (data) {
    this.setExpiresAtToLocalStorage();

    if(data === undefined){
      return;
    }

    var toBeStored = this.upsert(data);
    if(toBeStored[0]) {
      this.setLastNotificationTime(toBeStored[0].timestamp);
    }

    this.setToLocalStorage(toBeStored);
    this.changed();
  }

  static upsert(data){
    var existing = this.getFromLocalStorage();
    var existingTimestamps = existing.map((item)=>{
      return item.timestamp;
    });

    for (let i = 0; i < data.length; i++) {
      let existingIndex = existingTimestamps.indexOf(data[i].timestamp);

      if (existingIndex == -1) {
        let row = {
          title: data[i].title,
          body: data[i].body,
          url: data[i].url,
          timestamp: data[i].timestamp,
          read: false
        };
        existing.push(row);
      } else if(data[i].read)  {
        existing[existingIndex].read = true;
      }
    }

    return existing.sort((element1, element2) => element2.timestamp - element1.timestamp);
  }

  static nextExpiresAt(){
    var minute = 30;
    return Date.now() + (minute * 60 * 1000);
  }

  static shouldRefetchNotification(){
    return Date.now() > this.getExpiresAtFromLocalStorage();
  }

  static changed(){
    Topic.publish('notificationStorage/changed');
  }

  static onChange(callback){
    Topic.subscribeOnce("notificationStorage/changed", () => {
      callback();
    });
  }

  static setExpiresAtToLocalStorage(){
    LocalStorageAdapter.setItem(
      this.timeKey(),
      this.nextExpiresAt()
    );
  }

  static setLastNotificationTime(lastNotifTime){
    LocalStorageAdapter.setItem(
      this.lastNotificationTimeKey(),
      lastNotifTime
    );
  }

  static setLastReadKey() {
    const lastNotifTime = LocalStorageAdapter.getItem(this.lastNotificationTimeKey());
    if (lastNotifTime) {
      LocalStorageAdapter.setItem(this.lastReadKey(), lastNotifTime);
    }
  }

  static checkNewNotification() {
    const lastRead = LocalStorageAdapter.getItem(this.lastReadKey());
    const lastNotification = LocalStorageAdapter.getItem(this.lastNotificationTimeKey());
    return lastNotification > lastRead;
  }

  static getExpiresAtFromLocalStorage(){
    const expiresAt = LocalStorageAdapter.getItem(this.timeKey());
    if (expiresAt) {
      return parseInt(expiresAt);
    } else {
      return 0;
    }
  }

  static setToLocalStorage(data){
    LocalStorageAdapter.setItem(this.key(), JSON.stringify(data))
  }

  static getFromLocalStorage(){
    var dataset = [];
    var current = LocalStorageAdapter.getItem(this.key());

    try {
      if(current){
        dataset = JSON.parse(current);
      }
    } catch (error) {
      window.console.log(error);
    }

    return dataset;
  }

  static markAsRead(itemTimestamp) {
    let existingData = this.getFromLocalStorage();
    let itemIndex = existingData
      .map(datum => datum.timestamp)
      .indexOf(itemTimestamp);

    if ((itemIndex > -1) && !existingData[itemIndex].read) {
      existingData[itemIndex].read = true;
      this.setToLocalStorage(existingData);
    }
  }

  static clear(){
    LocalStorageAdapter.removeItem(this.key());
    LocalStorageAdapter.removeItem(this.timeKey());
    LocalStorageAdapter.removeItem(this.lastReadKey());
    LocalStorageAdapter.removeItem(this.lastNotificationTimeKey());
  }
}
